export default {
  BASE_URL: '/admin',
  api: [
    {
      name: 'homeInfo',
      desc: '首页信息',
      method: 'GET',
      path: '/home/info'
    },
    {
      name: 'updateMessage',
      desc: '将消息设置为已读',
      method: 'GET',
      path: '/crm/message/read'
    },
    {
      name: 'message',
      desc: '消息管理列表',
      method: 'GET',
      path: '/home/message'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/home/index.js